"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.TimelinePopinEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var fields_1 = require("../../fields");
var slices_1 = require("../../slices");
var popin_factory_1 = require("./popin-factory");
var toTimelineBloc = function (slices, logger) {
    var blocIndex = 0;
    var splittedSlices = slices.reduce(function (acc, slice) {
        if (acc.length <= blocIndex) {
            acc[blocIndex] = [];
        }
        if (slice.slice_type === types_1.SliceType.Divider) {
            blocIndex++;
            return acc;
        }
        acc[blocIndex].push(slice);
        return acc;
    }, []);
    return splittedSlices.map(function (slice) { var _a; return (_a = slices_1.toSlices(slice, logger)) === null || _a === void 0 ? void 0 : _a.filter(Boolean); });
};
exports.TimelinePopinEntity = popin_factory_1.popinFactory(types_1.DocumentType.TIMELINE_POPIN, function (prismicDoc, normalizedPopin, logger) {
    var _a, _b, _c, _d;
    return utils_1.compact(__assign(__assign({}, normalizedPopin), { subtitle: logger.required(fields_1.toText((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.subtitle)), text: logger.required(fields_1.toRichText((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.text, logger)), image: fields_1.toImage((_c = prismicDoc.data) === null || _c === void 0 ? void 0 : _c.image, logger), timeline_slices: toTimelineBloc((_d = prismicDoc.data) === null || _d === void 0 ? void 0 : _d.timeline_slices, logger) }));
});
//# sourceMappingURL=timeline-popin.js.map